export default __webpack_public_path__ + "static/media/I_WANNA_DRAW_DEATH_HARPIES_two.896b7cf9.png";